import { VouchersGetAllBody } from "@/lib/redux/features/voucher/voucherApiV3.types"

export type VoucherMarketKey = "all" | "DOMESTIC" | "INTERNATIONAL"

export const getVoucherMarketKey = (isDomestic?: boolean): VoucherMarketKey => {
  if (isDomestic === undefined) return "all"
  return isDomestic ? "DOMESTIC" : "INTERNATIONAL"
}

export const getVoucherMarketKeyFromBody = (body?: VouchersGetAllBody): VoucherMarketKey => {
  const market = body?.markets?.[0]
  if (market === "DOMESTIC" || market === "INTERNATIONAL") return market
  return "all"
}
